<template>
    <va-edit-layout>
        <NetworkComminglingTransactionEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></NetworkComminglingTransactionEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
